import { FETCH_STEPS } from '@/store/actions/onBoarding';

/**
 * @description Статусы ответов.
 * @type {string[]}
 */
const STATUSES_ON_BOARDING_STEPS = {
  passedStatues: [
    'passed',
  ],
  unPassedStatus: [
    'access_deny',
    'the_step_not_exist',
    'already_passed',
    'not_passed',
  ],
};
/**
 * @description Заголовок.
 * @type {string[]}
 */
const TITLE = 'on_boarding_status';

/**
 * @description Примесь профиля сотрудника.
 */
export default {
  computed: {
    listOnBoardingSteps() {
      return this.$store.getters.getSteps;
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * Проверяем ответ онбординга и обновляем список шагов если это нужно
     *
     * @param title
     * @param body
     */
    checkAndUpdate(title, body) {
      const isHasTitle = TITLE.includes(title);
      if (!isHasTitle) {
        return;
      }
      const isHasPassedStatus = STATUSES_ON_BOARDING_STEPS
        .passedStatues
        .includes(body.status);
      if (!isHasPassedStatus) {
        return;
      }
      if (this.isAllStepsPassed()) {
        return;
      }
      this.$store.dispatch(FETCH_STEPS);
    },
    /**
     * Проверяем все ли шаги онбординга пройдены
     *
     * @return {boolean}
     */
    isAllStepsPassed() {
      const allSteps = this.$store.getters.getSteps;
      let result = true;
      allSteps.forEach((el) => {
        if (el.isAccess === true && el.isPassed !== true && el.isHide !== true) {
          result = false;
        }
      });
      return result;
    },
  },
};
